import { createReducer } from '@reduxjs/toolkit';

import { IProfileState } from './interfaces';
import { Constants } from './constants';
import * as ProfileActions from './actions';

const initialProfileState: IProfileState = {
    mobile: undefined,
    emails: undefined,
    notificationSettings: undefined,
    isProfileDataLoaded: undefined,
};

export const profileReducer = createReducer(initialProfileState, {
    [Constants.PROFILE_SET_EMAILS]: (draftState, action: ReturnType<typeof ProfileActions.setEmails>) => {
        draftState.emails = action.payload.emails;
        draftState.isProfileDataLoaded = Boolean(draftState.mobile) && Boolean(draftState.notificationSettings);
    },

    [Constants.PROFILE_SET_MOBILE]: (draftState, action: ReturnType<typeof ProfileActions.setMobile>) => {
        draftState.mobile = action.payload.mobile;
        draftState.isProfileDataLoaded = Boolean(draftState.emails) && Boolean(draftState.notificationSettings);
    },
});
